import { Controller } from "@hotwired/stimulus"

// Controls theme switching between light and dark modes
export default class extends Controller {
  static targets = ["icon"]

  connect() {
    // Load saved theme or default to light
    const savedTheme = localStorage.getItem("theme") || "light"
    this.setTheme(savedTheme)
  }

  toggle() {
    const currentTheme = document.documentElement.getAttribute("data-theme")
    const newTheme = currentTheme === "dark" ? "light" : "dark"
    this.setTheme(newTheme)
    localStorage.setItem("theme", newTheme)
  }

  setTheme(theme) {
    document.documentElement.setAttribute("data-theme", theme)
    this.updateIcon(theme)
  }

  updateIcon(theme) {
    if (!this.hasIconTarget) return

    if (theme === "dark") {
      // Show sun icon (to switch to light)
      this.iconTarget.innerHTML = `
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path>
        </svg>
      `
    } else {
      // Show moon icon (to switch to dark)
      this.iconTarget.innerHTML = `
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path>
        </svg>
      `
    }
  }
}
